TrainDeviationarrival<template>
  <v-row>
    <v-col cols="9">
      <v-autocomplete
        full-width
        :items="places"
        :rules="[required]"
        :item-value="
          model.type === 'RST' && arrivalPlaces.length ? '_key' : 'short_name'
        "
        :item-text="item => `(${item.short_name}) ${item.stop_name}`"
        :filter="
          (item, query) =>
            item.short_name.toLowerCase().includes(query.toLowerCase()) ||
            item.stop_name.toLowerCase().includes(query.toLowerCase())
        "
        outlined
        label="Till"
        v-model="to"
      />
    </v-col>
    <v-col cols="3">
      <v-text-field
        :rules="[validTime]"
        v-model="time"
        type="time"
        label="Ankomsttid"
        outlined
        :disabled="model.type === 'RST'"
      />
    </v-col>
  </v-row>
</template>

<script>
import { format, addDays } from 'date-fns'
import { get, sync } from 'vuex-pathify'
import { validTime } from '@/common/validationRules'
import { required } from '@/common/validationRules'

export default {
  name: 'TrainDeviationArrivalFields',

  data: () => ({
    required,
    validTime,
    time: null
  }),

  computed: {
    stops: get('event/stops'),
    to: sync('trainDeviation/model@to'),
    model: sync('trainDeviation/model'),
    arrival: get('trainDeviation/model@arrival'),
    arrivalPlaces: get('trainDeviation/arrivalPlaces'),

    places() {
      return this.model.type === 'RST' && this.arrivalPlaces.length
        ? this.arrivalPlaces
        : this.stops
    }
  },

  watch: {
    to: {
      handler(value) {
        if (!value || this.model.type !== 'RST' || !this.arrivalPlaces.length) {
          this.time = format(new Date(this.arrival), 'HH:mm')
          return
        }
        const [, advertised] = value.split('_')

        this.$store.set('trainDeviation/model@arrival', new Date(advertised))
        this.time = format(new Date(advertised), 'HH:mm')
      },
      immediate: true
    },
    time(input) {
      if (this.model.type === 'RST') return

      const arrivalDate = format(new Date(this.model.departure), 'yyyy-MM-dd')
      const arrival = new Date(`${arrivalDate} ${input}`)
      if (arrival.getTime() < new Date(this.model.departure).getTime()) {
        this.$store.set(
          'trainDeviation/model@arrival',
          addDays(new Date(`${arrivalDate} ${input}`), 1)
        )
      } else {
        this.$store.set('trainDeviation/model@arrival', arrival)
      }
    }
  }
}
</script>
